<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="文件路径">
                <j-input placeholder="请输入文件路径" v-model.trim="queryParam.path"></j-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="文件类型">
                <j-input placeholder="请输入文件类型" v-model.trim="queryParam.type"></j-input>
              </a-form-item>
            </a-col>
            <span style="float: right; overflow: hidden" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              </a-col>
            </span>
          </a-row>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleUpload" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a
        style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        :scroll="{ x: false }"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <template slot="content" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <img v-else-if="record.type.includes('image')" :src="text" height="25px" alt="图片不存在"
               style="max-width:80px;font-size: 12px;font-style: italic;"/>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a style="color: #f56c6c;">删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <FileModal ref="modalForm" @ok="modalFormOk"></FileModal>
  </a-card>
</template>

<script>

import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import FileModal from './modules/FileModal'
import JInput from "@comp/jeecg/JInput";
import {putAction, getAction} from '@/api/manage'


export default {
  name: "FileConfigList",
  mixins: [JeecgListMixin],
  components: {
    JInput,
    FileModal
  },
  data() {
    return {
      description: '附件配置页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '文件名',
          align: "center",
          dataIndex: 'name',
          width: 200
        },
        {
          title: '文件路径',
          align: "center",
          dataIndex: 'path',
          width: 200,
          ellipsis: true,

        },
        {
          title: 'URL',
          align: "center",
          dataIndex: 'url',
          ellipsis: true,
          width: 200
        },
        {
          title: '文件大小',
          align: "center",
          dataIndex: 'size',
          customRender: this.fileSizeFormatter
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'type'
        },
        {
          title: '文件内容',
          align: "center",
          dataIndex: 'url',
          scopedSlots: {customRender: 'content'}
        },
        {
          title: '上传时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        list: "/file.base/file/page",
        // list: "/assetstorage.base/busAssetStorageDetail/list",
        delete: "/assetstorage.base/busAssetStorageDetail/delete",
        deleteBatch: "/assetstorage.base/busAssetStorageDetail/deleteBatch",
        exportXlsUrl: "/assetstorage.base/busAssetStorageDetail/exportXls",
        importExcelUrl: "assetstorage.base/busAssetStorageDetail/importExcel",
        updateMaster: "/file.base/file-config/update-master?id=",
        test: "/file.base/file-config/test?id="
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    initDictConfig() {
    },
    handleUpload() {
      this.$refs.modalForm.upload()
    },
    fileSizeFormatter (t, r, i) {
      const fileSize = t
      const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const srcSize = parseFloat(fileSize)
      const index = Math.floor(Math.log(srcSize) / Math.log(1024))
      const size = srcSize / Math.pow(1024, index)
      const sizeStr = size.toFixed(2) //保留的小数位数
      return sizeStr + ' ' + unitArr[index]
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>